import { render, staticRenderFns } from "./SubscriptionGroup.vue?vue&type=template&id=e0a7af02&scoped=true"
import script from "./SubscriptionGroup.vue?vue&type=script&lang=js"
export * from "./SubscriptionGroup.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionGroup.vue?vue&type=style&index=0&id=e0a7af02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a7af02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a7af02')) {
      api.createRecord('e0a7af02', component.options)
    } else {
      api.reload('e0a7af02', component.options)
    }
    module.hot.accept("./SubscriptionGroup.vue?vue&type=template&id=e0a7af02&scoped=true", function () {
      api.rerender('e0a7af02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/SubscriptionGroup.vue"
export default component.exports